export default __webpack_public_path__ + "static/media/lend-active.aba7a5fb.svg";